"use client";
import React, { useEffect, useState } from "react";
import CourseCard, { sortCoursesByAvailability, type Course } from "@/components/CourseCard";
import RegisterModal from "@/components/RegisterModal";

export default function OnlinePage() {
  const [courses, setCourses] = useState<Course[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<Course | null>(null);

  useEffect(() => {
    fetch("/api/courses")
      .then((res) => res.json())
      .then((data) => {
        const filteredCourses = data
          .filter((course: Course) => !course.hidden)
          .filter((course: Course) => course.location === "Online");
        setCourses(sortCoursesByAvailability(filteredCourses));
      });
  }, []);

  return (
    <div className="section-spacing">
      <div className="container">
        <h1 className="text-3xl font-bold text-slate-800">Cursos Online</h1>
        <div className="grid-courses mt-8">
          {courses.map((course) => (
            <CourseCard key={course.id} course={course} onRegister={setSelectedCourse} />
          ))}
        </div>
        {courses.length === 0 && (
          <p className="mt-4 text-slate-600">No hay cursos online disponibles en este momento.</p>
        )}
      </div>
      {selectedCourse && <RegisterModal course={selectedCourse} onClose={() => setSelectedCourse(null)} />} 
    </div>
  );
}
